import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { padding, stacked } from 'app/shared/styles/_spacing';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';
import DayPicker from 'app/shared/core/DayPicker';

export const MoveInDateButton = styled(ButtonBase)`
  ${font.tiny};
  ${stacked._2x};
  color: ${colors['$hpx-blue-600']};
  height: 40px;
`;

export const MoveInDateFilterSection = styled.section<{ $shouldCollapseSpacing?: boolean }>`
  ${(props) =>
    props.$shouldCollapseSpacing === false &&
    `
            padding-bottom: 52px;
    `};
  ${(props) =>
    props.$shouldCollapseSpacing === true &&
    `
            padding-bottom: 4px;
    `};
`;

export const StyledDayPicker = styled(DayPicker)`
  /** DAY PICKER CUSTOM STYLES */
  &.DayPicker {
    width: 292px;
    margin-bottom: 16px;
  }

  .DayPicker-Weekday abbr {
    text-decoration: none;
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  // Modifiers
  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):not(.DayPicker-Day--end) {
    color: ${colors['$hpx-white']};
    background-color: ${colors['$hpx-teal-500']};
  }

  .DayPicker-Day--selected.DayPicker-Day--end {
    color: ${colors['$hpx-white']};
    background-color: ${colors['$hpx-teal-600']};
    font-weight: bold;
  }

  .DayPicker-Day--selected.DayPicker-Day--end.DayPicker-Day--outside {
    color: ${colors['$hpx-white']};
    background-color: ${colors['$hpx-teal-600']};
    font-weight: bold;
  }

  .DayPicker-Day--disabled.DayPicker-Day--selected {
    background: ${colors['$hpx-teal-100']};
    color: ${colors['$hpx-grey-600']};
  }

  .DayPicker-Day--outside.DayPicker-Day--selected {
    background: ${colors['$hpx-teal-500']};
  }
`;

export const OnOrBeforeDateNote = styled.p`
  ${font.tiny};
  ${padding.top._1x};
  ${stacked._1x};
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;

  &::marker {
    ${font.sm};
    color: ${colors['$hpx-teal-600']};
    margin: 0;
  }
`;

export const ListingsNote = styled.p`
  ${font.sm};
  padding-top: 8px;
`;
